import {FC, useRef} from "react";
import styles from './Modal.module.scss'
import {classNames} from "@shared/utils";

type TModalProps ={
    children: React.ReactNode,
    isOpen: boolean,
    setIsOpen?: () => void
    onClose?: () => void
    position?: "center" | "top" | "bottom" | "left" | "right"
}

export const Modal: FC<TModalProps> = ({children, isOpen, onClose, setIsOpen, position = "center"}) => {

    const ref = useRef(null)

    const classNamesContent = classNames(
        styles.content,
        styles[`content_position_${position}`]
    )

    const handleCloseModal = (e) => {
        if (setIsOpen || onClose) {
            const {target} = e
            if (ref.current === target) {
                setIsOpen && setIsOpen()
                onClose && onClose()
            }
        }
    }
    if (isOpen) {
        return (
            <div
                className={styles.root}
                ref={ref}
                onClick={(e) => handleCloseModal(e)}
             >
                <div className={classNamesContent} onClick={e => e.stopPropagation()}>
                    {children}
                </div>
            </div>
        )
    }
}